import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import { ReactComponent as CloseIcon } from "assets/img/svg/CloseSquareBlack.svg";
import { getAuditLogs } from "./api";
import { getAcdCarrierList, getAcdLabelValue, viewTextStyle } from "./constant";
import ALoader from "views/pages/manage/common/a-loader";
const getLogsUpdatedValue = (logRow, dropdown) => {
  return `${logRow?.noOfDays} days, ${logRow?.status},${getAcdLabelValue(
    getAcdCarrierList(dropdown, logRow?.academicCareerIds)
  )} ticketId(${logRow?.ticketId})`;
};
const AuditLogDialogWithButton = ({
  row,
  academicCarrierDropdown,
}) => {
  const [open, setOpen] = useState(false);
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(false);
  const fetchAuditLogs = async () => {
    setLoading(true);
    try {
      const response = await getAuditLogs(row.id, "concessionReversal");
      if (response?.code === 200) {
        debugger;
        setLogs(response.data);
      }
    } catch (err) {
      console.error("Error fetching audit logs", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (open && row?.id) {
      fetchAuditLogs();
    }
  }, [open, row]);

  if (row?.isNew) return "";

  return (
    <>
      <div
        style={viewTextStyle}
        variant="outlined"
        onClick={() => setOpen(true)}
      >
        View
      </div>

      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          <div className="bold-heading-label color-dark" variant="h6">
            Logs • {row?.concessionCategory?.subSubCategoryDisplayValue}
          </div>
          <IconButton
            aria-label="close"
            onClick={() => setOpen(false)}
            sx={{ position: "absolute", right: 16, top: 16 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>
          {loading ? (
            <ALoader />
          ) : (
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell className="header-column">
                    <strong className="header-column"> Ticket No.</strong>
                  </TableCell>
                  <TableCell>
                    <strong className="header-column">Value</strong>
                  </TableCell>
                  <TableCell>
                    <strong className="header-column">Updated On</strong>
                  </TableCell>
                  <TableCell className="header-column">
                    <strong className="header-column">Updated By</strong>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {logs.map((log, index) => (
                  <TableRow key={index}>
                    <TableCell>{log.ticketId}</TableCell>
                    <TableCell>{getLogsUpdatedValue(log, academicCarrierDropdown)}</TableCell>
                    <TableCell>
                      {new Date(log.updatedOn).toLocaleString("en-GB", {
                        day: "2-digit",
                        month: "2-digit",
                        year: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                        hour12: true,
                      })}
                    </TableCell>
                    <TableCell>{log.updatedBy}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
};

export default AuditLogDialogWithButton;
